export enum ProviderSearchType
{
    Provider = 0,
    Group = 1
}